import {
  NOTIFICATION_CREATE_ORDER,
  NOTIFICATION_ORDER_ACTIONS
} from '../../config/notifications';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { OrderTable } from "../../components/pages/orderManagement/OrderTable";
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from '../layout/Dashboard';
import { Messages } from "../../components/layout/Messages/Messages";
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { CreateOrder } from '../../components/pages/orderManagement/actionButtons/CreateOrder';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './OrderManagement.scss';

function OrderManagementComponent(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title" />}
      workspace
      {...props}
    >
      <PageWorkspace className="orders-list-workspace">
        <PageHeader
          actions={<CreateOrder/>}
          title={<FormattedMessage id="pages.orderManagement.title" />}
        />
        <div className="orders-list-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_ORDER_ACTIONS}/>
          <Messages notificationId={NOTIFICATION_CREATE_ORDER}/>
        </div>
        <PageSurface className="orders-list-surface">
          {ACL.CLIENT.ORDERS.LIST.hasAccess() ? <OrderTable/> : <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const OrderManagement = connect(null, { hideNotification })(OrderManagementComponent);

export { OrderManagement, OrderManagementComponent };
